module.exports = __webpack_public_path__ + "img/hands.4e00178c.png";